export default __webpack_public_path__ + "static/media/avatar.059498a2.jpeg";